module.exports = __webpack_public_path__ + "img/WL-BS-banner-normol.9e7fd6c3.png";